export interface TranslationApiModel {
  id: string;
  tenant_id?: string;
  locale_id: string;
  translation_key_id: string;
  translation: string;
}
